import { defineMessages } from "react-intl";

export const freemiumMessages = defineMessages({
  agreementBannerTxt: {
    defaultMessage:
      "To improve our products, Cayosoft collects anonymized usage telemetry. You can change this in Settings after you finish the product installation",
    id: "freemium-messages.agreementBannerTxt",
  },

  agreementBannerTxtHosted: {
    defaultMessage: "To improve our products, Cayosoft collects anonymized usage telemetry.",
    id: "freemium-messages.agreementBannerTxtHosted",
  },

  // ----- ACTIVATION PLAN
  freeTitle: {
    defaultMessage: "Free",
    id: "freemium-messages.freeTitle",
  },
  freeSubtitle: {
    defaultMessage: "Forever free, with an option to try commercial features",
    id: "freemium-messages.freeSubtitle",
  },
  fullTitle: {
    defaultMessage: "Full Install",
    id: "freemium-messages.fullTitle",
  },
  fullSubtitle: {
    defaultMessage: "Start a 25-day trial or use an existing Cayosoft subscription",
    id: "freemium-messages.fullSubtitle",
  },

  // List — Free
  freeItem1: {
    defaultMessage: "Two-Week Change History for AD, Entra ID, Intune",
    id: "freemium-messages.freeItem1",
  },
  freeItem2: {
    defaultMessage: "Scheduled Threat Assessment Reports",
    id: "freemium-messages.freeItem2",
  },
  freeItem3: {
    defaultMessage: "Real-Time Threat Detection Alerts",
    id: "freemium-messages.freeItem3",
  },
  freeItem4: {
    defaultMessage: "Change Alerts and Reports",
    id: "freemium-messages.freeItem4",
  },

  // List — Full Install
  fullIntro: {
    defaultMessage: "Everything in Free, plus:",
    id: "freemium-messages.fullIntro",
  },
  fullItem1: {
    defaultMessage: "Unlimited Change History & Data Retention",
    id: "freemium-messages.fullItem1",
  },
  fullItem2: {
    defaultMessage: "Roll Back any Change in Change History",
    id: "freemium-messages.fullItem2",
  },
  fullItem3: {
    defaultMessage: "Set Up Automated Rollback for Unwanted Changes",
    id: "freemium-messages.fullItem3",
  },
  fullItem4: {
    defaultMessage: "Custom Alerts",
    id: "freemium-messages.fullItem4",
  },
  fullItem5: {
    defaultMessage: "Delegation",
    id: "freemium-messages.fullItem5",
  },
  fullItem6: {
    defaultMessage: "Full AD Forest Recovery",
    id: "freemium-messages.fullItem6",
  },

  // ----- END ACTIVATION PLAN

  trialPlan: {
    defaultMessage: "Trial Plan",
    id: "freemium-messages.trialPlan",
  },

  free: {
    defaultMessage: "Free",
    id: "freemium-messages.free",
  },

  update: {
    defaultMessage: "Update",
    id: "freemium-messages.update",
  },

  upgrade: {
    defaultMessage: "Upgrade",
    id: "freemium-messages.upgrade",
  },

  learnProducts: {
    defaultMessage: "Learn more about Cayosoft Products",
    id: "freemium-messages.learnProducts",
  },

  daysLeft: {
    defaultMessage: "{days, plural, one {# day left} other {# days left}}",
    id: "freemium-messages.daysLeft",
  },

  expired: {
    defaultMessage: "Expired",
    id: "freemium-messages.expired",
  },

  chRestriction: {
    defaultMessage:
      "Change History is limited to 14 days. Upgrade to access all your data. {learnMore}",
    id: "freemium-messages.chRestriction",
  },

  learnGuardian: {
    defaultMessage: "Learn more about Cayosoft Guardian products.",
    id: "freemium-messages.learnGuardian",
  },

  learnMore: {
    defaultMessage: "Learn more.",
    id: "freemium-messages.learnMore",
  },

  // trial features

  featureUnlimitedHistory: {
    defaultMessage: "Unlimited Change History",
    id: "freemium-messages.featureUnlimitedHistory",
  },
  featureRollback: {
    defaultMessage: "Rollback/Auto Rollback",
    id: "freemium-messages.featureRollback",
  },
  featureAlerts: {
    defaultMessage: "Adding and Editing Alerts",
    id: "freemium-messages.featureAlerts",
  },
  featureDelegation: {
    defaultMessage: "Delegation",
    id: "freemium-messages.featureDelegation",
  },
  featureSettings: {
    defaultMessage: "Service Settings",
    id: "freemium-messages.featureSettings",
  },
  featureJobs: {
    defaultMessage: "Jobs and Jobs History",
    id: "freemium-messages.featureJobs",
  },
  featureAndMore: {
    defaultMessage: "And more...",
    id: "freemium-messages.featureAndMore",
  },
  andMore: {
    defaultMessage: "And more...",
    id: "freemium-messages.andMore",
  },
});
